module.exports = __webpack_public_path__ + "static/media/case-01-mobile.9bf1024a.png";